import React from "react";
import { Box, Typography } from "@mui/material";
import { DashboardKpiCard } from "./DashboardKpiCard";
import { DashboardKpiGridProps } from "./types";
import {
  DashboardSectionDivider,
  useActivateDashboardSection,
} from "../DashboardSectionDivider";

export const DashboardKpiGrid: React.FC<DashboardKpiGridProps> = ({
  title,
  subtitle,
  items,
  columns = { xs: 1, sm: 2, md: 5, lg: 5 },
  onCardClick,
  isLoading = false,
  sectionId = "kpi",
}) => {
  const { activateSection } = useActivateDashboardSection();

  return (
    <Box
      sx={{ mt: 2.75 }}
      onClickCapture={() => activateSection(sectionId)}
    >
      <DashboardSectionDivider sectionId={sectionId} />
      <Box sx={{ mb: 1.5 }}>
        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            color: "#111827",
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "12px",
              color: "#6b7280",
              mt: 0.25,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: `repeat(${columns.xs || 1}, minmax(0, 1fr))`,
            sm: `repeat(${columns.sm || 2}, minmax(0, 1fr))`,
            md: `repeat(${columns.md || 5}, minmax(0, 1fr))`,
            lg: `repeat(${columns.lg || 5}, minmax(0, 1fr))`,
          },
          gap: 1.25,
        }}
      >
        {items.map((item) => (
          <DashboardKpiCard
            key={item.id}
            item={item}
            onClick={onCardClick ? () => onCardClick(item.id) : undefined}
            isLoading={isLoading}
          />
        ))}
      </Box>
    </Box>
  );
};
